import { API_ERROR_MESSAGE, DYNAMIC_API_ERROR_MESSAGE } from '../i18n/errorMessages';
import CardModalExceptions from '../exceptions/CardModalExceptions';
import constants from '../constants';

export const getErrorMessage = (errorKey, errorMessage) => API_ERROR_MESSAGE[errorKey]
    || (DYNAMIC_API_ERROR_MESSAGE[errorKey] && DYNAMIC_API_ERROR_MESSAGE[errorKey](errorMessage))
    || API_ERROR_MESSAGE.CONTACT_SUPPORT;

export const handleApiError = (errors) => {
    const [errorKeyAndValue] = Object.entries(errors);
    const [errorKey, errorMessage] = errorKeyAndValue;
    return getErrorMessage(errorKey, errorMessage);
};

export const checkCardIntegrity = (card) => {
    const { assignees, assignee } = card;
    const isCardWithoutAssignee = !assignee || assignees.length === 0;
    const isCardManual = card.control_type === constants.CARD_CONTROL_TYPES.MANUAL;

    if (isCardManual && !card.temporaryId && isCardWithoutAssignee) {
        throw new CardModalExceptions.CardWithoutAssigneesError(card);
    }
};

export const getErrorKey = (response, defaultErrorKey) => (
    response?.data?.errors && Object.keys(response.data.errors)[0]
) || defaultErrorKey;
